/*
 * Copyright (c) 2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { useEffect } from 'react';
import { useColorMode } from '@getgo/chameleon-chakra-ui';

import { changeFavicon } from '../../services/FaviconService';
import { ColorTheme } from '../../themes/GoToTheme';

export const darkFaviconLocation = '/static/media/goto-favicon-dark.svg';

export const ThemeSwitcher: React.FC<{ colorMode: ColorTheme }> = (props) => {
  const { colorMode, children } = props;
  const { setColorMode } = useColorMode();
  useEffect(() => {
    if (colorMode === ColorTheme.dark) {
      changeFavicon(process.env.PUBLIC_URL + darkFaviconLocation);
    }
    setColorMode(colorMode);
  }, [colorMode, setColorMode]);
  return <>{children}</>;
};
